import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "~/components/ui/accordion";

// Questions and answers are design placeholders, identical in every locale.
const FAQ_ITEMS = ["item_1", "item_2", "item_3", "item_4", "item_5"] as const;

// Must render inside the .fleet token scope.
export function FleetFaq() {
  const { t } = useTranslation("fleet");

  return (
    <section aria-labelledby="fleet-faq-title" className="py-8 lg:py-[60px]">
      <div className="wrap flex flex-col gap-6 lg:gap-10">
        <h2
          id="fleet-faq-title"
          className="font-display text-text-heading text-center text-xl leading-7 font-extrabold lg:text-left lg:text-4xl lg:leading-[1.1]"
        >
          {t("faq.title")}
        </h2>
        <Accordion type="single" collapsible className="flex flex-col gap-1">
          {FAQ_ITEMS.map((key, i) => (
            <AccordionItem key={key} value={key} className="border-bg-alt bg-transparent">
              <AccordionTrigger data-sid={`fleet-faq-trigger:${i}`} className="text-text-heading-alt gap-4 text-left">
                <span>{t(`faq.items.${key}.question`)}</span>
              </AccordionTrigger>
              <AccordionContent>{t(`faq.items.${key}.answer`)}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}

export default FleetFaq;
